<template>
  <v-select
    @change="handleKeyLocationSelect"
    v-model="keyLocation"
    :rules="rules"
    :items="appointmentKeyLocations"
    :label="$t('appointment.formCreate.labels.keyLocation')"
    item-value="value"
    item-text="label"
    outlined
  />
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex'
import { appointmentKeyLocations } from '../appointmentFormDefaults'

export default {
  name: 'KeyLocation',

  props: {
    rules: {
      type: Array,
    },
  },

  data() {
    return {
      keyLocation: null,
      appointmentKeyLocations,
    }
  },

  computed: {
    ...mapGetters(['appointmentFields', 'appointmentFormStepsTotal']),
  },

  methods: {
    ...mapMutations(['setAppointmentFields', 'setIsLoading']),
    ...mapActions(['fetchBranch']),

    handleKeyLocationSelect(value) {
      const { key_location_options } = this.appointmentFields

      if (value === 'REAL_ESTATE') {
        const branchId = this.appointmentFields.real_estate_branch_id

        if (this.appointmentFormStepsTotal <= 5) {
          this.fetchBranch(branchId)
        }
      }

      this.setAppointmentFields({
        key_location_options: { ...key_location_options, key_location: value },
      })
    },
  },

  mounted() {
    if (this.appointmentKeyLocations.length >= 1) {
      this.keyLocation = this.appointmentKeyLocations[0].value
      this.handleKeyLocationSelect(this.appointmentKeyLocations[0].value)
    }
  },
}
</script>
